import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getSecteurCultures, getSecteurInformations } from 'services/API/Secteur';

import { useNavigate } from 'react-router-dom';
import { sendEvent } from 'utils/Event';
import DataGridRotateEffects from '../Cooperative/DataGridRotateEffects';
import Sector from 'components/icons/Cooperative';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';

const RotateEffectsDataGridSector = ({ sectorFromParent, from }) => {
  const [cultures, setCultures] = useState(null);
  const navigate = useNavigate();
  const [sector, setSector] = useState(sectorFromParent);
  const [rotations, setRotations] = useState([]);
  const sectorId = sector?.id ?? +localStorage.getItem('sector');

  const { isOrganic } = useToggleSwitch(from, 'rotateEffects', () => {}, sectorId, null, null);

  useEffect(() => {
    if (!sector) {
      if (!sector && localStorage.getItem('sector')) {
        getSecteurInformations(sectorId)
          .then((resp) => {
            setSector(resp.data.data);
          })
          .catch((err) => toast.error(err.data));
      } else {
        toast.info('Selectionnez un secteur');
        navigate('/sector');
      }
    }
    // Dismount
    return () => {
      sendEvent('cancelHttpRequest');
    };
  }, []);

  useEffect(() => {
    if (sector) {
      refreshData(isOrganic, sectorId);
    }
  }, [sector]);

  useEffect(() => {
    if (cultures?.length) {
      setRotations(cultures[0]?.rotationEffects);
    }
  }, [cultures]);

  const refreshData = (isOrganic, sectorId) => {
    if (!sectorId) {
      sectorId = localStorage.getItem('sector');
    }
    getSecteurCultures(isOrganic, sectorId)
      .then((resp) => {
        setCultures(resp?.data?.data?.sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch(() => toast.error);
  };

  return (
    <>
      <p className="title_spacing">
        <span className="subtitle_spacing">
          <Sector width={30.0} height={30} fill="$secondary" />
        </span>
        <span className="green_text subtitle_spacing">{sector?.name} </span>
      </p>
      <DataGridRotateEffects
        from={from}
        cultures={cultures?.filter((culture) => culture.isCustomized === true)}
        ownerId={sectorId}
        refreshData={refreshData}
      />
    </>
  );
};

export default RotateEffectsDataGridSector;
